import { Injectable } from '@angular/core';
import { DashboardUserService } from '@rma/authentication/public/user';
import { CurrentSubscriptionService } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { ProfileType } from '@rma/generic/domain/to-be-sorted';
import { FeaturesService, TempFeatureFlags } from '@rma/generic/util/feature-flags';
import { cache } from 'decorator-cache-getter';
import { combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TeamCalloutService {
  constructor(
    private readonly dashboardUserService: DashboardUserService,
    private readonly currentSubscriptionService: CurrentSubscriptionService,
    private readonly featuresService: FeaturesService,
  ) {}

  @cache
  public get showTeamsCallout$() {
    return combineLatest([
      this.featuresService.getFeature$(TempFeatureFlags.ShowTeamsBanner),
      this.currentSubscriptionService.currentSubscription$,
      this.dashboardUserService.currentDashboardContext$,
      this.dashboardUserService.currentUser$.pipe(map((x) => x?.agencies?.filter((y) => y.agentGroupingType === 'Team') ?? [])),
    ]).pipe(
      map(
        ([feature, currentSubscription, currentDashboardContext, existingTeamAdmin]) =>
          feature &&
          !currentSubscription.isProvided &&
          currentDashboardContext.profileType === ProfileType.Individual &&
          !currentSubscription.onTrial &&
          !currentSubscription.isFree &&
          existingTeamAdmin.length === 0,
      ),
    );
  }
}
